export type TzBinding = {
  scope: 'global' | 'user' | 'niche' | 'user_niche' | 'source' | 'user_source';
  subject_id: number | null;
  source_code?: string | null;
  template_id: string;
};

export type TzTemplate = {
  id: string;
  name: string;
  prompt: string;
  model_id: string;
  fill_desc: boolean;
  fill_eng_desc: boolean;
  fill_season: boolean;
  is_public: boolean;
  browser_model_id?: string | null;
  browser_prompt?: string | null;
  is_owner: boolean;
  score_avg?: number | null;
  score_count?: number;
  spend_runs?: number;
  spend_tokens?: number;
  spend_cost?: number | null;
  spend_avg_cost?: number | null;
  spend_avg_tokens?: number | null;
};

// Порядок тот же, что в src/services/tzPrompt.js resolveTemplateId.
export function resolveTzTemplateId(bindings: TzBinding[], subjectId: number, sourceCode?: string): string | null {
  const subject = Number(subjectId);
  const source = sourceCode || '';
  const find = (scope: TzBinding['scope'], matchSubject: boolean, sourceMode: 'exact' | 'any') =>
    bindings.find((row) => {
      if (row.scope !== scope) return false;
      if (matchSubject && Number(row.subject_id) !== subject) return false;
      const rowSource = row.source_code || '';
      if (sourceMode === 'exact') return rowSource === source && source !== '';
      return rowSource === '';
    });
  return find('user_niche', true, 'exact')?.template_id
    || find('niche', true, 'exact')?.template_id
    || find('user_niche', true, 'any')?.template_id
    || find('niche', true, 'any')?.template_id
    || find('user_source', false, 'exact')?.template_id
    || find('source', false, 'exact')?.template_id
    || find('user', false, 'any')?.template_id
    || find('global', false, 'any')?.template_id
    || null;
}

export function effectiveTzTemplate(
  templates: TzTemplate[],
  bindings: TzBinding[],
  subjectId: number,
  overrideId?: string,
  sourceCode?: string
): TzTemplate | null {
  const byId = (id?: string | null) => templates.find((template) => template.id === id) || null;
  return byId(overrideId) || byId(resolveTzTemplateId(bindings, subjectId, sourceCode));
}
